



































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {SelectWings, InputWings} from "wings-ui-components";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import {PushDeviceItem} from "@/store/push/devices/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {SelectWings, InputWings}})
export default class PushDevice extends Vue {
  @Ref('validator') validator: any;

  @Action("getPushDevicesItem") actionGetItem: any;
  @Action("deletePushDevice") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item: PushDeviceItem = Object.create({});
  private logObject: ActionLog = {};

  created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Contact",
        addititional_info: getTranslatedParams(this.item)
      }
      this.actionGetItem(this.$route.params.id).then((data: PushDeviceItem)=>{
        this.item = Object.assign({}, this.item, data);
        this.actionLog(this.logObject);
      }).catch(() => this.actionLog({...this.logObject, action_status: "failed"}));
    }
  }

  back(): void {
    this.$router.push(`/push/devices`);
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete(this.$t('dialog.deletion_in_one_minute').toString());
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }
}
